import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@zenbusiness/zui/Accordion';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const InvoiceCardRoot = superstyled({
  name: 'PaymentReturnInvoiceCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(15,22,28,0.04), 0px 1.5px 3px -0.5px rgba(15,22,28,0.08)',
    overflow: 'hidden',
  }),
});

export const InvoiceCardHeader = superstyled({
  tag: Stack,
  name: 'InvoiceCard',
  slot: 'Header',
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
  }),
});

export const InvoiceCardAccordion = superstyled({
  tag: Accordion,
  name: 'InvoiceCard',
  slot: 'Accordion',
  styles: {
    '&:before': {
      display: 'none',
    },
  },
});

export const InvoiceCardExpandIcon = superstyled({
  tag: ExpandMoreIcon,
  name: 'InvoiceCard',
  slot: 'ExpandIcon',
  styles: {
    width: 24,
    height: 24,
  },
});
